var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('div',{ref:"helpHtml",domProps:{"innerHTML":_vm._s(_setup.markdownHtml)}}),_vm._v(" "),_vm._l((_setup.internalHelpReferences),function(value,i){return _c('span',{key:i},[_c(_setup.HelpPopover,{attrs:{"target":value.element,"term":value.term}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }